import { render, staticRenderFns } from "./transferMediate.vue?vue&type=template&id=320182d7&scoped=true&"
import script from "./transferMediate.vue?vue&type=script&lang=js&"
export * from "./transferMediate.vue?vue&type=script&lang=js&"
import style0 from "./transferMediate.vue?vue&type=style&index=0&id=320182d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320182d7",
  null
  
)

export default component.exports